/* template */
<template><mpx-view @tap="clickExtra" class="small-package-wrapper"><div class="lighting-icon-wrapper"/><mpx-image src="https://ut-static.udache.com/webx/sfc/cklKfatdT5bxrnRTTic6q.png" class="new-icon" v-if="(firstSee)"/><div class="top-area" v-if="(amount)"><span class="amount">{{ amount }}</span><span class="unit">个</span></div><div class="bottom-area"><span class="name" v-if="(name)">{{ name }}</span></div></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m19054b33"}'>
  .small-package-wrapper
    flex 1
    display flex
    flex-direction column
    align-items center
    justify-content center
    margin-right 10px
    border-radius 8px
    background #FFF7E6
    border 0.75px solid rgba(255, 89, 0, 0.4)
    box-sizing border-box
    position relative
    .new-icon
      position absolute
      height 17px
      width 33px
      z-index 3
      top -6.5px
      left 0px
    &:last-child
      margin-right 0
    .top-area
      z-index 2
      .amount, .unit
        font-weight 600
        color #FF5900
      .amount
        font-family Barlow Semi Condensed
        font-size 24px
        font-weight 400
      .unit
        font-family PingFang SC
        line-height 11px
    .bottom-area
      z-index 2
      font-size 9px
      font-weight 400
      color #B38369
      max-width 90%
      overflow hidden
      text-overflow ellipsis
      line-height 15px
      .name
        white-space nowrap
        font-family PingFang SC
    .lighting-icon-wrapper
      z-index 1
      position absolute
      width 100%
      height 100%
      left 0
      top 0
      border-radius 8px
      overflow hidden
      &::after
        content ''
        position absolute
        width: 26.5px;
        height: 38.5px
        bottom -5px
        right -1.5px
        background-image url('https://ut-static.udache.com/webx/sfc/ZoccEWWoIAb5F4qQt09A6.png')
        background-size cover
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m19054b33"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./small-package.mpx.js?isComponent&outputPath=components%2Fsmall-package19054b33%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./small-package.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsmall-package19054b33%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m19054b33"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/small-package19054b33/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
